import { isSSR } from '@utils/isSSR';

export function getStoreLocation() {
  const STORE_LOCATION_DEFAULT = { locationNumber: '', address: { zipCode: null } };
  const lsValue = isSSR() ? STORE_LOCATION_DEFAULT : JSON.parse(window.localStorage.getItem('commonstorelocation') || '{}');
  const clientLsReference = Object.keys(lsValue)?.length ? lsValue : STORE_LOCATION_DEFAULT;
  const commonStoreLocation = isSSR()
    ? STORE_LOCATION_DEFAULT
    : clientLsReference;

  return {
    zipcode: commonStoreLocation?.address?.zipCode,
    store: commonStoreLocation?.locationNumber,
  };
}

export default getStoreLocation;
